/* eslint max-params: ["error", 5] */

import './attachment-details.scss';
import React, {PropTypes} from 'react';
import AttachmentInfo from './attachment-info';
import {Checkbox} from 'cap-it-ui.toggles';
import File from '@deere/cps-it.warranty-model-factory/lib/file';
import FileAttachmentPanelRga from './file-attachment-panel';
import {FormattedMessage} from 'react-intl';
import ListViewShowMore from '../../../../../../shared/components/list-view-show-more';
import RefinableListWidget from '../../../../../../shared/components/refinable-list-widget';
import RgaDetails from '../../../../../rga-search-results/state/rga-details';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import WarrantyLoadingIndicator from '../../../../../../shared/components/warranty-loading-indicator';
import {create as createHashMap} from '../../../../../../shared/services/hashmap';
import {downloadFileRga} from '../../../../../../shared/services/file-download';

const sortOptions = [
    {
        displayName: 'File Type',
        path: ['source']
    }
];

const searchFilters = {
    filterBy: '',
    query: '',
    sortBy: ['source'],
    sortDirection: 'DESC'
};

function handleFileUploadSuccess(file, dropzone) {

    const fileObject = JSON.parse(file.xhr.response);

    this.setState(prevState => ({
        files: [...prevState.files, fileObject]
    }));
    dropzone.removeFile(file);

}

function handleFileDelete(file) {

    this.props.actions.deleteFileRga(file, this.state.files);

    this.setState(prevState => ({
        files: prevState.files.filter(f => !(f.serialNumber === file.serialNumber && f.fileName === file.fileName))
    }));

}

function onFileDownloadClick() {

    this.state.selectedFiles.forEach(file => {

        downloadFileRga(file);

    });

    this.setState({
        isSelectedAllFiles: true,
        selectedFiles: []
    });

}

function resetSelectedFiles() {

    this.setState({
        isSelectedAllFiles: true,
        selectedFiles: []
    });

}

function sortFileCollectionBySource() {

    const sortedFiles = [...this.state.filesSortedCollection].sort((a, b) => {

        if (a.source < b.source) {

            return -1;

        }
        if (a.source > b.source) {

            return 1;

        }
        return 0;

    });

    this.setState({
        filesSortedCollection: sortedFiles
    });

}

function filterFilesBySource(source) {

    const filteredFiles = this.props.fileCollection.filter(file =>
        file.source && file.source.toLowerCase().includes(source.toLowerCase())
    );

    this.setState({
        filesSortedCollection: filteredFiles
    });

    searchFilters.filterBy = source;

}

function addAllFilesToSelected() {

    if (this.state.isSelectedAllFiles) {

        this.setState({
            selectedFiles: this.state.filesSortedCollection
        });

    } else {

        this.setState({
            selectedFiles: []
        });

    }
    this.setState(prevState => ({
        isSelectedAllFiles: !prevState.isSelectedAllFiles
    }));

}
class AttachmentDetails extends React.Component {
    constructor(props) {

        super(props);
        this.state = {
            files: [],
            filesSortedCollection: [...props.fileCollection],
            intialLoad: true,
            isSelectedAllFiles: true,
            selectedFiles: []
        };

    }
    componentWillMount() {

        if (this.props.rgaDetails.rgaNumber && this.props.rgaDetails.warrantyClaimNumber) {

            this.props.actions.getRgaFiles(this.props.rgaDetails);

        }

    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.fileCollection !== this.props.fileCollection) {

            this.setState({
                filesSortedCollection: [...nextProps.fileCollection]
            });

        }

    }
    handleFileSelect(file, account, isSelected) {

        if (isSelected) {

            this.setState(prevState => ({
                selectedFiles: [...prevState.selectedFiles, file]
            }));

        } else {

            this.setState(prevState => ({
                selectedFiles: prevState.selectedFiles.filter(f => f.serialNumber !== file.serialNumber || f.objectKey !== file.objectKey)
            }));

        }

    }
    render() {

        return (
            <section className='rga-recalled-form'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <div className='list-files'>
                    <RefinableListWidget
                        onFilterByChange={filterFilesBySource.bind(this)}
                        onSortByChange={sortFileCollectionBySource.bind(this)}
                        onSortDirectionChange={sortFileCollectionBySource.bind(this)}
                        searchFilters={searchFilters}
                        sortOptions={sortOptions}
                    />
                    <ListViewShowMore
                        initialShowItems={50}
                        perMoreMultiplier={1.25}
                        showAllOption={true}
                        showPerMore={50}
                        totalItems={this.props.fileCollection.length}
                    >
                        <section className='button-group recalled-button-group'>
                            <button
                                className='secondary'
                                onClick={resetSelectedFiles.bind(this)}
                            >
                                <FormattedMessage id='CANCEL'/>
                            </button>
                            <button
                                className='primary'
                                onClick={onFileDownloadClick.bind(this)}
                            >
                                <FormattedMessage id='Download'/>
                            </button>
                        </section>
                        <Checkbox
                            id={!this.state.isSelectedAllFiles}
                            onChange={addAllFilesToSelected.bind(this)}
                            selected={!this.state.isSelectedAllFiles}
                        >{this.state.isSelectedAllFiles ? <FormattedMessage id='SELECT_ALL'/> : <FormattedMessage id='DESELECT_ALL'/>}</Checkbox>
                        {this.state.filesSortedCollection.map((item, index) =>
                            <AttachmentInfo
                                actions={this.props.actions}
                                handleFileSelect={this.handleFileSelect.bind(this, item)}
                                initialState={createHashMap(this.state.selectedFiles, 'serialNumber')}
                                item={item}
                                key={index}
                                uid={'serialNumber'}
                            />
                        )}
                    </ListViewShowMore>
                </div>
                {this.props.security.role === 'RGA_USER' ? null :
                <FileAttachmentPanelRga
                    files={this.state.files}
                    onFileDelete={handleFileDelete.bind(this)}
                    onFileUploadSuccess={handleFileUploadSuccess.bind(this)}
                    serviceConfig={{
                        className: 'BUS2222',
                        classType: 'BO',
                        objectKey: `RGA${this.props.rgaDetails.rgaNumber}${this.props.rgaDetails.warrantyClaimNumber}`
                    }}
                />}
            </section>
        );

    }
}

AttachmentDetails.displayName = 'AttachmentDetails';
AttachmentDetails.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    fileCollection: PropTypes.arrayOf(PropTypes.instanceOf(File)).isRequired,
    rgaDetails: PropTypes.instanceOf(RgaDetails).isRequired,
    security: PropTypes.instanceOf(Security).isRequired
};

export default AttachmentDetails;



// WEBPACK FOOTER //
// ./src/rga/recalled-part-analysis/components/returned-part-information/recalled-part-tab/components/attachment-details.js